import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { BusinessAccount } from '@models/business-account';
import { AuthorizationService } from '@services/authorization.service';
import { StorageService } from '@services/storage.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BusinessAccountService {
  private http = inject(HttpClient);
  private authService = inject(AuthorizationService);
  private storage = inject(StorageService);

  /**
   * Determines whether upsells should be skipped for the current order.
   *
   * @returns {boolean} true when the current order is an active business account order on a site that skips upsells
   */
  public shouldSkipUpsells(): boolean {
    return environment.order.skipUpsellsForBusinessAccounts && !!this.storage.baOrder?.isActive;
  }

  /**
   * Fetches the business account details for the given business account ID using the provided authentication token.
   *
   * @param {number} businessAccountId The ID of the business account to retrieve.
   * @param {string} token The authentication token to include in the request headers for authorization.
   */
  public getBusinessAccount(businessAccountId: number, token: string): Observable<BusinessAccount> {
    return this.http.get<BusinessAccount>(
      `${environment.analyteCareApi}/my-account/business-accounts/${businessAccountId}`,
      this.authService.getOptionsWithAuthHeader(token),
    );
  }
}
